import * as React from "react";
import "./chargeEmailButton.scss";

var ChargeEmailButton = function ChargeEmailButton(props) {
  var poliza_payment_id = props.poliza_payment_id,
      button_text = props.button_text;

  var handleEmailButtonClick = function handleEmailButtonClick() {
    window.location.href = "/admin/poliza_payments/".concat(poliza_payment_id);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cntChargeEmailButton"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: handleEmailButtonClick
  }, button_text || "Email de cobranza"));
};

export default ChargeEmailButton;